<template>
  <header class="fixed-top px-content-1">
    <div class="d-flex flex-wrap justify-content-end">
      <a
        href="javascript:void(0)"
        class="ui_mobile"
        data-bs-toggle="modal"
        data-bs-target="#menu_home_mobile"
      >
        <img src="@/assets/images/menu.svg" />
      </a>
      <img
        src="@/assets/images/logo-FA_color 1.png"
        class="order-unow-logo"
        v-if="this.$route.name === 'luckyDraw'"
      />
    </div>
  </header>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Header",
};
</script>

<style scoped></style>
